module.exports = __webpack_public_path__ + "img/logo.0e0d87e8.png";